import axiosInstance from '../../helpers/axiosInstance'

export default function getProvinciasService () {
    return axiosInstance.get("provincias")
        .then(response => response.data)
        .catch(error => {
          throw error;
        });
}